export default "__VITE_ASSET__BqtDGoKH__"